(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dt-auction-grid"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const chip = event.target.closest('[data-dt-chips] .dt-chip');
    if (!chip) return;
    const bar = chip.closest('[data-dt-chips]');
    const grid = document.getElementById(bar.dataset.dtChips);
    if (!grid) return;
    const wanted = chip.dataset.category;
    bar.querySelectorAll('.dt-chip').forEach((c) => {
      const on = c === chip;
      c.classList.toggle('is-active', on);
      c.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    grid.querySelectorAll(':scope > li').forEach((li) => {
      li.hidden = wanted !== '' && li.dataset.category !== wanted;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dt-auction-strip"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const pad = (n) => String(n).padStart(2, '0');
    const left = (ms) => {
      const s = Math.max(0, Math.floor(ms / 1000));
      const d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60);
      if (d > 0) return `${d}d ${h}h`;
      if (h > 0) return `${h}h ${pad(m)}m`;
      return `${m}m ${pad(s % 60)}s`;
    };
    const timers = new Set();
    const tick = () => {
      const now = Date.now();
      timers.forEach((t) => {
        const ms = t.end - now;
        t.el.textContent = ms > 0 ? t.track.dataset.labelEnds.replace('__TIME__', left(ms)) : t.track.dataset.labelEnded;
        if (ms <= 0) timers.delete(t);
      });
    };
    const load = async (track, card) => {
      const url = `${track.dataset.proxy}/auction?product_id=${encodeURIComponent(card.dataset.dtLot)}&shop=${encodeURIComponent(track.dataset.shop)}`;
      try {
        const res = await fetch(url, { headers: { Accept: 'application/json' } });
        if (!res.ok) return;
        const json = await res.json();
        const data = json && json.data ? json.data : null;
        if (!json || json.success === false || !data || !data.id) return;
        const li = card.closest('li');
        if (li && li.hasAttribute('data-dt-pending') && (!data.status || data.status === 'ACTIVE')) {
          li.hidden = false;
          const strip = li.closest('[data-dt-strip]');
          if (strip) strip.hidden = false;
        }
        const price = card.querySelector('[data-dt-lot-bid]');
        const amount = parseFloat(data.currentPrice ?? data.startingBid);
        if (price && Number.isFinite(amount)) {
          price.textContent = new Intl.NumberFormat(track.dataset.locale || undefined, { style: 'currency', currency: track.dataset.currency || 'USD' }).format(amount);
          const wait = card.querySelector('[data-dt-lot-bid-wait]');
          if (wait) wait.removeAttribute('data-dt-lot-bid-wait');
        }
        const count = parseInt(data.bidCount, 10);
        const countEl = card.querySelector('[data-dt-lot-count]');
        if (countEl && Number.isFinite(count) && !(data.widgetSettings && data.widgetSettings.hideBidCount)) {
          countEl.textContent = (count === 1 ? track.dataset.labelBidsOne : track.dataset.labelBidsOther).replace('__N__', count);
          countEl.hidden = false;
        }
        const end = data.endTime ? new Date(data.endTime).getTime() : NaN;
        const el = card.querySelector('[data-dt-lot-timer]');
        if (el && Number.isFinite(end)) {
          el.hidden = false;
          timers.add({ el, end, track });
          tick();
        }
      } catch (e) {}
    };
    const init = (root) => {
      root.querySelectorAll('[data-dt-live-bids]').forEach((track) => {
        if (track.dataset.dtBound) return;
        track.dataset.dtBound = '1';
        track.querySelectorAll('[data-dt-lot]').forEach((card) => load(track, card));
      });
    };
    setInterval(tick, 1000);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
    else init(document);
    document.addEventListener('shopify:section:load', (e) => init(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
